import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'
import {
    isUserModerator,
    createDisplayName,
    isUserAdmin,
} from '../../misc/auth-utils'
import Tag from '../common/tag'
import IconButton from './icon-button'
import IconButtonLabel from './icon-button-label'
import LockStatusIcon from './lock-status-icon'
import StatusBalls from './status-balls'
import VisibilityStatusIcon from './visibility-status-icon'
import { connect } from 'react-redux'
import { selectIdea, deleteIdea } from '../../store/actions/ideas'
import { confirmationDialog } from './confirmation-dialog'

export class IdeaSummaryCard extends React.Component {
    static propTypes = {
        redirectMode: PropTypes.bool.isRequired,
        idea: PropTypes.object.isRequired,
    }

    isNew() {
        return (
            moment(Date.now()).diff(
                moment(this.props.idea.submitted_at),
                'days'
            ) < 3
        )
    }

    isCurrentUserPublisher = () => {
        if (!this.props.idea.publisher || !this.props.idea.publisher.email)
            return false
        return this.props.auth.user.email === this.props.idea.publisher.email
    }

    // STATUS CHANGE

    onIdeaStatusChange = (value) => {
        this.props.onIdeaStatusChange && this.props.onIdeaStatusChange(value)
    }

    onLockStatusChange = (value) => {
        this.props.onLockStatusChange && this.props.onLockStatusChange(value)
    }

    onVisibilityStatusChange = (value) => {
        this.props.onVisibilityStatusChange &&
            this.props.onVisibilityStatusChange(value)
    }

    shouldRedirect = () => {
        if (this.props.redirectMode) {
            this.props.selectIdea(this.props.idea._id)

            this.props.history.push({
                pathname: '/idea',
            })
            return true
        }
        return false
    }

    onComponentClick = () => {
        if (this.shouldRedirect()) return
    }

    onLikeClick = () => {
        if (this.shouldRedirect()) return
        this.props.onLikeClick && this.props.onLikeClick()
    }

    onCommentClick = () => {
        if (this.shouldRedirect()) return
        this.props.onCommentClick && this.props.onCommentClick()
    }

    onEditIdeaClick = () => {
        if (this.shouldRedirect()) return
        this.props.history.push({
            pathname: '/submit',
            query: { editExisting: true },
            editExisting: true,
        })
    }

    onDeleteIdeaClick = () => {

        confirmationDialog({
            title: 'Delete Idea',
            text: 'Do you wish to delete the Idea?',
            positiveText: 'Delete',
            positiveColor: 'primary',
            negativeText: 'Cancel',
            negativeColor: 'secondary',

            positiveCallback: () => {
                this.props.deleteIdea(this.props.idea._id)
            },
        })
    }

    render() {
        var submittedMoment = moment(this.props.idea.submitted_at)

        const renderTags = () => {
            return (
                <>
                    {this.isNew() && <label className="new-tag">NEW</label>}
                    {this.props.idea.tags.map((tag) => (
                        <Tag key={tag} text={tag.toUpperCase()} />
                    ))}
                </>
            )
        }

        return (
            <>
                <div
                    className={
                        this.props.redirectMode
                            ? 'idea-explorer-navigation-clickable'
                            : ''
                    }
                    onClick={this.onComponentClick}>
                    <div className="row align-items-center">
                        {/* IDEA ICON */}
                        <h2 className="col-sm-1 idea-card-icon text-lg-right text-primary align-bottom mb-0 pl-2">
                            <FontAwesomeIcon icon={this.props.idea.icon} />
                        </h2>

                        {/* TITLE, DATE, SUBMITTER */}
                        <div className="col-md-11 col-lg-6 idea-card">
                            <h4>{this.props.idea.title}</h4>
                            <p
                                rel="tooltip"
                                title={submittedMoment.format('LLLL')}>
                                Submitted {submittedMoment.fromNow()} by{' '}
                                {createDisplayName(this.props.idea.publisher)}
                            </p>
                            <div className="inline-block">{renderTags()}</div>
                        </div>

                        {/* STATUSES */}
                        <div className="col-xs-12 col-lg-2 ml-auto ">
                            <div className="row justify-content-center">
                                {/* VISIBILITY STATUS */}
                                <div className="col-xs-3">
                                    {isUserModerator(this.props.auth.user) && (
                                        <VisibilityStatusIcon
                                            status={
                                                this.props.idea
                                                    .visibility_status
                                            }
                                            onClick={
                                                this.onVisibilityStatusChange
                                            }
                                        />
                                    )}
                                </div>

                                {/* LOCK STATUS */}
                                <div className="col-xs-3 ">
                                    {isUserModerator(this.props.auth.user) && (
                                        <LockStatusIcon
                                            status={this.props.idea.lock_status}
                                            onClick={this.onLockStatusChange}
                                        />
                                    )}
                                </div>

                                {/* EDIT IDEA */}
                                <div className="col-xs-1 ">
                                    {this.props.idea.lock_status ===
                                        'unlocked' &&
                                        this.isCurrentUserPublisher() && (
                                            <IconButton
                                                icon="edit"
                                                onClick={this.onEditIdeaClick}
                                            />
                                        )}
                                </div>

                                {/* IDEA STATUS - always visible */}
                                <div className="col-xs-3 ">
                                    <StatusBalls
                                        status={this.props.idea.status}
                                        disabled={
                                            !isUserModerator(
                                                this.props.auth.user
                                            )
                                        }
                                        onClick={this.onIdeaStatusChange}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* VOTES */}
                        <div className="col-sm-2 ml-auto text-center">
                            <IconButtonLabel
                                text={this.props.idea.like_count}
                                icon="thumbs-up"
                                onClick={this.onLikeClick}
                                pressed={this.props.idea.liked_by_user}
                            />
                            <div className="mt-2 mb-1" />
                            <IconButtonLabel
                                text={this.props.idea.comment_count}
                                icon="comment-alt"
                                onClick={this.onCommentClick}
                            />
                        </div>
                    </div>
                </div>
                {/* DELETE - always visible for admin */}

                {isUserAdmin(this.props.auth.user) && this.props.redirectMode &&  (
                    <div className="row">
                        <div className="col text-right">
                            <IconButton
                                icon="trash"
                                onClick={this.onDeleteIdeaClick}
                            />
                        </div>
                    </div>
                )}
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
})

export default withRouter(
    connect(mapStateToProps, { selectIdea, deleteIdea })(IdeaSummaryCard)
)
